import { gql } from "@apollo/client";

export const UPDATE_USER_MUTATION = gql`
	mutation User($params: UserInputParam) {
		user(params: $params) {
			update {
				id
				name
				emails {
					address
					verified
					type
				}
			}
		}
	}
`;
